const sizesData = [
  {
    id: 1,
    class: "monthlyArountChestReport",
    title: "دور سینه",
    label: "chest_circumference"
  },
  {
    id: 2,
    class: "monthlyArountArmReport",
    title: "دور بازو",
    label: "arm_circumference"
  },
  {
    id: 3,
    class: "monthlyArountBellyReport",
    title: "دور ناف",
    label: "stomach_circumference"
  },
  {
    id: 4,
    class: "monthlyArountHipReport",
    title: "دور باسن",
    label: "pelvis_circumference"
  },
  {
    id: 5,
    class: "monthlyArountThighReport",
    title: "دور ران",
    label: "thigh_circumference"
  },
  {
    id: 6,
    class: "monthlyArountLegReport",
    title: "دور ساق پا",
    label: "leg_circumference"
  },
];

export default sizesData;
